import { supabase } from '../SupabaseClient/supabase-client'
import type { FiiAnalysisData } from '@/types/FiiAnalysis'

const FUNCTION_NAME = 'fii-analysis'

export const fiiAnalysisService = {
  async getByTicker(ticker: string): Promise<FiiAnalysisData> {
    const { data, error } = await supabase.functions.invoke(`${FUNCTION_NAME}?ticker=${ticker}`, { method: 'GET' })
    if (error) throw error
    return data as FiiAnalysisData
  },
}
